import reducer from './reducer';
import container from './container';

// export { reducer, container };

export default {
  reducer,
  container,
};
